module.exports = __webpack_public_path__ + "img/icon-end-to-end.971db7b8.svg";